module.exports = __webpack_public_path__ + "img/3d-tablet_jp.ba8e8f1.jpg";